import React from 'react';

/** SAP-style golden arrow — opens linked master data (e.g. Business Partner). */
export default function BpGoldenArrow({ title, onClick, disabled }) {
  return (
    <button
      type="button"
      title={title}
      aria-label={title || 'Open linked master'}
      onClick={(e) => { e.stopPropagation(); onClick(e); }}
      disabled={disabled}
      className="inline-flex flex-shrink-0 items-center justify-center min-w-[20px] min-h-[20px] hover:opacity-90 transition-opacity disabled:opacity-30 disabled:cursor-not-allowed"
    >
      <svg width="14" height="14" viewBox="0 0 14 14" className="drop-shadow-sm" aria-hidden>
        <polygon points="1,1 13,7 1,13" fill="#E8A000" stroke="#C47800" strokeWidth="0.85" strokeLinejoin="round" />
      </svg>
    </button>
  );
}
